import img1 from "../../assets/Images/Access Control/User Management.png"
import img2 from "../../assets/Images/Access Control/Create Users.png"

export default function Users() {
    return (
        <section id="users" className="space-y-16">

            {/* SECTION TITLE */}
            <section className="bg-white rounded-xl border border-slate-200 p-10">
                <h1 className="text-2xl font-bold text-slate-900 mb-2">
                    2. User Management
                </h1>

                <p className="text-md text-slate-600 max-w-3xl">
                    User Management allows administrators to create system users, assign
                    roles, and control module-level access.
                </p>

                <section className="bg-white border-l border-[#C9A24E] p-4 mt-4">
                    <h2 className="text-lg font-semibold mb-3">Overview</h2>
                    <p className="text-slate-600 text-sm">
                        Each user in EventFlow is assigned a role and specific module
                        permissions to ensure secure and efficient system usage.
                    </p>
                </section>
            </section>

            {/* USER LIST */}
            <section className="">
                <div>
                    <h3 className="font-semibold mb-2">Users List</h3>

                    <p className="text-slate-600 mb-4">
                        Displays all registered users along with their assigned roles and
                        system status.
                    </p>

                    <ul className="list-disc pl-5 text-slate-600 space-y-1">
                        <li>User name</li>
                        <li>Email & phone</li>
                        <li>Assigned role</li>
                        <li>Status (Active / Inactive)</li>
                        <li>Edit action</li>
                    </ul>
                </div>

                <div className="rounded-lg p-4 mt-4">
                    <img src={img1} alt="" />
                </div>
            </section>

            {/* ADD USER */}
            <section className="bg-white border border-slate-200 rounded-xl p-8">
                <h3 className="font-semibold mb-2">Creating a New User</h3>

                <p className="text-slate-600 mb-4">
                    Clicking <strong>Add User</strong> opens the Create User form where
                    login and access details are defined.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>Name, Phone, Email</li>
                    <li>Password for system login</li>
                    <li>Role assignment</li>
                    <li>Module access selection</li>
                </ul>

                <div className="rounded-lg p-4 mt-4">
                    <img src={img2} alt="" />
                </div>
            </section>

            {/* MODULE ACCESS */}
            <section className="bg-slate-100 rounded-xl p-8">
                <h3 className="font-semibold mb-2">Module Access Control</h3>

                <p className="text-slate-600 mb-4">
                    Module access checkboxes determine which sections of EventFlow a user
                    can view and operate.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>Select All Permissions option</li>
                    <li>Dashboard</li>
                    <li>Event Estimates & Bookings</li>
                    <li>Reports & Accounting</li>
                    <li>Procurement & Expenses</li>
                    <li>Role & User Management</li>
                </ul>
            </section>

            {/* WHY IMPORTANT */}
            <section className="bg-slate-100 rounded-xl p-8">
                <h3 className="font-semibold mb-2">Why User Management Matters</h3>

                <p className="text-slate-600 max-w-3xl">
                    Proper user management prevents unauthorized access, protects sensitive
                    data, and ensures every user sees only what is relevant to their role.
                </p>
            </section>

        </section>
    );
}
